type IssueLinksFieldValue = {
	type: {
		name: string;
	};
	outwardIssue: {
		key: string;
	};
};

function isIssueLinksFieldValue(value: unknown): value is IssueLinksFieldValue {
	return (
		typeof value === 'object' &&
		value !== null &&
		'type' in value &&
		typeof value.type === 'object' &&
		value.type !== null &&
		'name' in value.type &&
		typeof value.type.name === 'string' &&
		'outwardIssue' in value &&
		typeof value.outwardIssue === 'object' &&
		value.outwardIssue !== null &&
		'key' in value.outwardIssue &&
		typeof value.outwardIssue.key === 'string'
	);
}

export function toIssueLinksFieldValue(value: unknown): IssueLinksFieldValue | undefined {
	return isIssueLinksFieldValue(value) ? value : undefined;
}
